import { Component, Input, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { IconType } from '../../types/misc';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent implements OnInit {
  @Input() name: IconType;

  private readonly ICON_SPRITE_ID = 'icon-sprite' as const;

  get getWidth(): string {
    return this.size;
  }

  get getHeight(): string {
    return this.size;
  }

  get style(): Record<string, string> {
    return {
      width: `${this.getWidth}px`,
      height: `${this.getHeight}px`,
    };
  }

  public size: string = '20';
  public iconName: string;

  constructor(private http: HttpClient) {}

  get viewBox(): string {
    let viewBox =
      document
        .querySelector(`#${this.ICON_SPRITE_ID}`)
        ?.querySelector(`#${this.iconName}`)
        ?.getAttribute('width') ?? this.size;

    if (viewBox > this.size) {
      viewBox = this.size;
    }

    return `0 0 ${viewBox} ${viewBox}`;
  }

  ngOnInit(): void {
    const iconParts = this.name.split('-');
    this.iconName = this.name;

    const size = iconParts.pop();
    if (size && !isNaN(parseInt(size))) {
      this.size = size;
      this.iconName = iconParts.join('-');
    }

    if (!document.querySelector(`#${this.ICON_SPRITE_ID}`)) {
      const elem = document.createElement('div');
      elem.id = this.ICON_SPRITE_ID;
      document.body.append(elem);

      const headers = new HttpHeaders();
      headers.set('Accept', 'image/svg+xml');

      this.http
        .get('assets/icons/icons.svg', { headers, responseType: 'text' })
        .pipe(
          catchError((err) => {
            elem.remove();
            return of(err);
          })
        )
        .subscribe((svg) => {
          elem.innerHTML = svg;
        });
    }
  }
}
